import { Component, OnInit } from '@angular/core';
import { ModelService } from '../../model.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Config } from '../../classes/config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

  authValue = '';
  log = '';
  btn = 'Authenticate';
  config: Config;

  user = JSON.parse(localStorage.getItem('currentUser'));
  user_name = 'Please Login to Continue';

  constructor(
    private router: Router,
    private modelService: ModelService,
  ) { }


  ngOnInit() {

    this.modelService.logout().subscribe(
      data => {
        console.log("logged Out");
        //alert("You are currently logged out...");
      },
      err => {
        console.log("Error occured.");
      }
    );

  }

  authUser(value: string): void {
    this.log = 'Checking: ' + value;
    this.btn = 'Checking';
    this.modelService.checkAuthentication(this.authValue).subscribe(
      data => {
        this.config = data;
        if (this.config.code == 200) {
          console.log('Authenticated User: ' + this.config.userData.name);
          localStorage.setItem('currentUser', JSON.stringify(this.config.userData));
          this.router.navigate(['leaderboard']);
        } else {
          console.log('Incorrect Code: ' + this.config.code);
          this.log = "Authentication Error, try again"
          this.btn = 'Retry';
        }
      },
      err => {
        console.log("Error occured.");
      }
    );
  }

  keyDownFunction(event, value:string) {
    if (event.keyCode == 13) {
      //alert('you just clicked enter');
      this.authUser(value);
      // rest of your code
    }
  }

}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/content/login/login.component.ts